import axios from 'axios';
import { toast } from 'react-toastify';
import {
  COLLECTIONS_UPDATE_LOOKUP_BEGIN,
  COLLECTIONS_UPDATE_LOOKUP_SUCCESS,
  COLLECTIONS_UPDATE_LOOKUP_FAILURE,
  COLLECTIONS_UPDATE_LOOKUP_DISMISS_ERROR,
} from './constants';
import { builderSurfaceJsonContentHeader } from '../../../common/utils/restApiHeaderUtils';

export function updateLookup(args = {}) {
  return (dispatch) => {
    dispatch({
      type: COLLECTIONS_UPDATE_LOOKUP_BEGIN,
    });
    const { projectId, collectionUuid, finderId, version, enabledLookups } = args;
    const header = builderSurfaceJsonContentHeader(projectId);
    const url = process.env.REACT_APP_BUILDER_ENGINE;
    const promise = new Promise((resolve, reject) => {
      const doRequest = axios.post(
        `${url}v${version}/finders/${collectionUuid}/collection/${finderId}/lookup`,
        enabledLookups,
        header,
      );
      doRequest.then(
        (res) => {
          dispatch({
            type: COLLECTIONS_UPDATE_LOOKUP_SUCCESS,
            data: res.data,
          });
          toast.success('Updated Successfully !');
          resolve(res);
        },
        (err) => {
          dispatch({
            type: COLLECTIONS_UPDATE_LOOKUP_FAILURE,
            data: { error: err },
          });
          toast.error('Failed to update !');
          reject(err);
        },
      );
    });

    return promise;
  };
}

export function dismissUpdateLookupError() {
  return {
    type: COLLECTIONS_UPDATE_LOOKUP_DISMISS_ERROR,
  };
}

export function reducer(state, action) {
  switch (action.type) {
    case COLLECTIONS_UPDATE_LOOKUP_BEGIN:
      return {
        ...state,
        updateLookupPending: true,
        updateLookupError: null,
      };

    case COLLECTIONS_UPDATE_LOOKUP_SUCCESS:
      return {
        ...state,
        updateLookupPending: false,
        updateLookupError: null,
        selectedCollection: action.data,
      };

    case COLLECTIONS_UPDATE_LOOKUP_FAILURE:
      return {
        ...state,
        updateLookupPending: false,
        updateLookupError: action.data.error,
      };

    case COLLECTIONS_UPDATE_LOOKUP_DISMISS_ERROR:
      return {
        ...state,
        updateLookupError: null,
      };

    default:
      return state;
  }
}
